import React, { useContext } from 'react'
import styled from 'styled-components'
import { AppContext } from '../../contexts/AppContext'

const Container = styled.div`
    margin: 60px 10%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

const Title = styled.h2`
    text-transform: uppercase;
` 

const Condition = styled.p`
    font-size: 12pt;
    font-weight: 300;
`

export default function ResidentialConditions() {

    const { appState } = useContext(AppContext);

    return (
        <Container>
            <Title>{appState.i18n.conditions.title}</Title>
            <Condition>{appState.i18n.plansConditions.home.condition1}</Condition>
            <Condition>{appState.i18n.plansConditions.home.condition2}</Condition>
            <Condition>{appState.i18n.plansConditions.home.condition3}</Condition>
            <Condition>{appState.i18n.plansConditions.home.condition4}</Condition>
            <Condition>{appState.i18n.plansConditions.home.condition5}</Condition>
            <Condition>{appState.i18n.plansConditions.home.condition6}</Condition>
            <Condition>{appState.i18n.plansConditions.home.condition7}</Condition>
            <Condition>{appState.i18n.plansConditions.home.condition8}</Condition>
        </Container>
    )
}
